import React from 'react';
import { Card } from 'react-bootstrap';
import style from './CustomPageDetailContentFormError.module.scss';

const CustomPageDetailContentFormError = (props) => {

  return (
    <Card>
      <Card.Body>
        <div>
          <div>
            <h1>ただいまアクセスが集中しています
              <span className={style.statusCode}>E10001</span>
            </h1>
            <p>
              大変申し訳ございません。<br/>
              以下の原因によりページを表示することができません。
            </p>
            <ul>
              <li><i className="fa fa-circle"></i> 大量のアクセスが集中している</li>
              <li><i className="fa fa-circle"></i> システムに不具合がある</li>
            </ul>
            <p>お手数ですが、しばらく経ってから再度お試しください</p>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

CustomPageDetailContentFormError.propTypes = {
};

export default CustomPageDetailContentFormError;
